// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:22:18

export default {
  "id": "brawl-stars",
  "slug": "brawl-stars",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8364fda6b3d2459dabf7429219c9cbbd-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8364fda6b3d2459dabf7429219c9cbbd/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Brawl Stars Sound",
      "description": "Listen to the voices and enjoy the visuals of the Brawl Stars characters. Start your sound-filled brawling adventure and enjoy a unique auditory twist in your gaming routine!",
      "instructions": "Press the buttons of different characters to hear unique sounds and see exciting visual effects appear!",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "brawl",
        "clicker"
      ]
    },
    "zh-CN": {
      "title": "斗地主之星音效",
      "description": "聆听声音，欣赏《斗士之星》角色的视觉呈现。开始你的充满音效的战斗冒险，享受游戏常规中的独特听觉体验！",
      "instructions": "按下不同角色的按钮，听独特声音并看到令人兴奋的视觉效果出现！",
      "genres": [
        "模拟"
      ],
      "tags": [
        "混战",
        "点击器"
      ]
    },
    "zh-TW": {
      "title": "鬥將星聲",
      "description": "聆聽這些聲音並欣賞《鬥巨星》角色的視覺效果。啟動你的音樂充滿的鬥鬥冒險，並在遊戲日常中享受獨特的聽覺變奏！",
      "instructions": "按壓不同角色的按鈕，聆聽獨特的聲音，並欣賞精彩的視覺效果出現！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "混戰",
        "點擊器"
      ]
    },
    "zh-HK": {
      "title": "鬥搶之星 音效",
      "description": "聆聽角色聲音，欣賞《搗蛋巨星》的角色視覺。開啟充滿聲音的搗蛋冒險，享受遊戲規律中的獨特聽覺轉折！",
      "instructions": "按住不同角色的按鈕，聆聽獨特聲音，並欣賞驚艷視覺效果出現！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "鬥鬥",
        "點擊器"
      ]
    },
    "ja": {
      "title": "ブラウルスターズ サウンド",
      "description": "声を聞いて、ブラストスターズキャラクターのビジュアルを楽しみなさい。音に満ちたブラウリングアドベンチャーを始め、ゲームの常套手段にユニークな音の要素を加えてみなさい！",
      "instructions": "異なるキャラクターのボタンを押して、ユニークな音と興奮する視覚効果が現れます！",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "乱闘",
        "クリッカーゲーム"
      ]
    },
    "ko": {
      "title": "브롤 스타즈 사운드",
      "description": "소리를 들어보고 Brawl Stars 캐릭터들의 시각을 즐겨보세요. 소리 가득한 브루어링 모험을 시작하고, 게임 루틴에 독특한 청각적인 전환을 즐겨보세요!",
      "instructions": "다른 캐릭터의 버튼을 눌러 독특한 소리를 들으며 흥미진진한 시각 효과를 볼 수 있습니다!",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "격투",
        "클리커"
      ]
    },
    "fr": {
      "title": "Brawl Stars Son",
      "description": "Écoutez les voix et profitez des visuels des personnages de Brawl Stars. Commencez votre aventure de combat sonore et profitez d'une touche auditive unique dans votre routine de jeu !",
      "instructions": "Appuyez sur les boutons de différents personnages pour entendre des sons uniques et voir des effets visuels passionnants apparaître !",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "Bagarre",
        "clickeur"
      ]
    }
  }
};
